import SEOxProjectOverview from './SEOxProjectOverview.container';

export default SEOxProjectOverview;
